import { create } from 'zustand';

type OrgState = {
  currentOrgId: string | null;
  role: 'owner' | 'member' | null;
  setOrg: (orgId: string, role: 'owner' | 'member') => void;
  clearOrg: () => void;
};

export const useOrgStore = create<OrgState>((set) => ({
  currentOrgId: null,
  role: null,
  setOrg: (orgId, role) => set({ currentOrgId: orgId, role }),
  clearOrg: () => set({ currentOrgId: null, role: null }),
}));
